import { useCustomSearchParams } from 'common/hooks/customSearchParams';
import { ContainerSearch } from 'components/PillSearch';
import * as React from 'react';
import { triggerPickupScraping } from 'services/clients/watchList';
import { SHIPMENTS_QUERY_PARAMS } from '../params';
import { UnwatchedState } from './types';

export const Search: React.FC = () => {
  const { searchParams, setSearchParams } = useCustomSearchParams(SHIPMENTS_QUERY_PARAMS, true);

  return (
    <ContainerSearch
      onSearch={(containerNumbers) => {
        if (containerNumbers.length > 0) {
          setSearchParams(
            {
              containerNumbers,
              unwatchedState: UnwatchedState.WatchedAndUnwatched,
            },
            false
          );
          triggerPickupScraping(containerNumbers);
        } else {
          // Resets unwatch state to default (null) when no containers are selected
          setSearchParams({ containerNumbers, unwatchedState: null }, false);
        }
      }}
      containerNumbers={searchParams.containerNumbers}
    />
  );
};
